import { SettingService } from './../../../../shared/services/setting.service';
import { CommonService } from './../../../../shared/services/common.service';
import { AllotmentService } from './../../../services/allotment.service';
import { ISetting } from './../../../../_models/cms/ISetting';
import { IKeyValuePair } from './../../../../_models/common/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

@Component({
  selector: 'app-allotment-form',
  templateUrl: './allotment-form.component.html',
  styleUrls: ['./allotment-form.component.css']
})
export class AllotmentFormComponent implements OnInit {

  year: number = new Date().getFullYear();
  skeleton: boolean = true;
  loading: boolean;
  title: string = 'Edit Employee Merit';
  employeeMerit: any;
  employeeMeritForm: FormGroup;
  id;
  profileId;

  schoolLevels: IKeyValuePair[];
  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];
  transferReasons: IKeyValuePair[];
  transferCategories: IKeyValuePair[];
  vacancyTypes: IKeyValuePair[];

  setting: ISetting;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private service: AllotmentService,
    private commonService: CommonService,
    private settingService: SettingService,
    private _location: Location) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.profileId = this.route.snapshot.paramMap.get('profileId');

  }

  async ngOnInit() {
    this.createEmployeeMeritForm();

    this.setting = await this.settingService.getSetting();

    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: any) => {
      if (response) {
        this.employeeMerit = response;
        this.title = 'Edit Employee Merit';
        this.setValueEmployeeMeritForm();
      }
    });

    this.skeleton = false;
  }


  bindDropDown() {

    this.commonService.getSchoolLevels().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schoolLevels = response;
      }
    });

    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });

    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });

    this.commonService.getTransferReasons().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.transferReasons = response;
      }
    });

    this.commonService.getTransferCategories().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.transferCategories = response;
      }
    });

    this.commonService.getVacancyTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.vacancyTypes = response;
      }
    });
  }

  changeDepartment(value) {
    if (value != 1) {
      this.getSchools(null, value);
    }
  }

  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number, schoolLevelId?: number) {
    this.commonService.getSchools(districtId, schoolLevelId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  createEmployeeMeritForm() {
    this.employeeMeritForm = this.fb.group({
      id: ['0'],
      profileId: [''],
      schoolLevelId: [''],
      regionId: [''],
      stateId: [''],
      districtId: [''],
      schoolId: [''],
      transferCategoryId: [''],
      vacantPostId: [''],
      vacancyTypeId: [''],
      remark: ['']
    });
  }

  setValueEmployeeMeritForm() {
    if (this.employeeMerit.school) {
      if (this.employeeMerit.school.regionId) {
        this.getStates(this.employeeMerit.school.regionId);
      }

      if (this.employeeMerit.school.stateId) {
        this.getDistricts(this.employeeMerit.school.stateId);
      }

      if (this.employeeMerit.school.districtId || this.employeeMerit.school.schoolLevelId) {
        this.getSchools(this.employeeMerit.school.districtId, this.employeeMerit.school.schoolLevelId);
      }
    }

    this.employeeMeritForm.patchValue({
      id: this.employeeMerit.id,
      profileId: this.employeeMerit.profileId,
      schoolLevelId: this.employeeMerit.school ? this.employeeMerit.school.schoolLevelId : '',
      regionId: this.employeeMerit.school ? this.employeeMerit.school.regionId : '',
      stateId: this.employeeMerit.school ? this.employeeMerit.school.stateId : '',
      districtId: this.employeeMerit.school ? this.employeeMerit.school.districtId : '',
      schoolId: this.employeeMerit.schoolId ?? '',
      transferCategoryId: this.employeeMerit.transferCategoryId,
      vacantPostId: this.employeeMerit.vacantPostId,
      vacancyTypeId: this.employeeMerit.vacantPostId ? this.employeeMerit.vacantPost.vacancyTypeId : '',
      remark: this.employeeMerit.remark 
    });
  }

  save() {    
    if (this.employeeMeritForm.valid) {
      this.loading = true;
      this.employeeMerit = Object.assign({}, this.employeeMeritForm.value);
      if (this.id) {
        this.service.update(this.id, this.employeeMerit).subscribe(() => {
          this.toastrService.success('Employee Merit updated successful');
          const page = localStorage.getItem('relativeUrl'); 
          this.router.navigateByUrl(page); 
          //this.router.navigate(['/management/allotment']);
          
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.employeeMerit).subscribe(() => {
          this.toastrService.success('Employee Merit created successful');
          const page = localStorage.getItem('relativeUrl'); 
          this.router.navigateByUrl(page);
          //this.router.navigate(['/management/allotment']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  cancel() {
   // this._location.back();
   window.history.back();
  }

}
